import { render, staticRenderFns } from "./TiarcoChemicalMMonthlyComparison.vue?vue&type=template&id=f5128484"
import script from "./TiarcoChemicalMMonthlyComparison.vue?vue&type=script&lang=ts"
export * from "./TiarcoChemicalMMonthlyComparison.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports